import { render, staticRenderFns } from "./InstitutionalPageModal.vue?vue&type=template&id=0b3dca11"
import script from "./InstitutionalPageModal.vue?vue&type=script&lang=js"
export * from "./InstitutionalPageModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports